export interface SupplierDetails {
  id: string;
  key: string;
  name: string;
  line1: string;
  line2: string;
  line3: string;
  line4: string;
  townCity: string;
  region: string;
  postCode: string;
  countryId: string;
  tel: string;
  fax: string;
  mobile: string;
  email: string;
  web: string;
  vatRegNo: string;
  obsolete: boolean;
  accountCode: string;
  internal: boolean;
  crmAccountCode: string;
  mobileNo: string;
  sellingCompanyId: string;
  currencyId: string;
  bankId: string;
  taxId: string;
  paymentTermId: string;
  shipper: boolean;
  multiLineAddress: string;
}
